import { MascotImage, useIntl, UserCredentials } from '@capsicum/common';
import { GenericDrawer, ModalService } from '@capsicum/common-web';

type UseGenericDeniedCredentialModalProps = {
	deniedCredential?: UserCredentials;
	onDismiss?: () => void;
};

export const useGenericDeniedCredentialModal = ({
	deniedCredential,
	onDismiss
}: UseGenericDeniedCredentialModalProps) => {
	const { $t } = useIntl();

	const showCustomMessage = deniedCredential === UserCredentials.BUY_TOKEN;

	const showGenericDeniedModal = () => {
		ModalService.addModal({
			detached: true,
			onDismiss: onDismiss,
			renderComponent: ({ close }) => (
				<GenericDrawer
					buttonText={$t('global.close')}
					description={$t(
						`jurisdictionRequirements.genericHandler.${showCustomMessage ? 'customMessage' : 'message'}`
					)}
					image={MascotImage}
					testID="generic-denied-reason-drawer"
					title={$t(`jurisdictionRequirements.genericHandler.${showCustomMessage ? 'customTitle' : 'title'}`)}
					onButtonPress={close}
				/>
			)
		});
	};

	return {
		showGenericDeniedModal
	};
};
